import React, { ReactNode, useLayoutEffect } from 'react';

import { THEME_TYPES, ThemeProvider, ThemeType } from '@infoods/lifebase-ui';
import { ErrorBoundary } from 'react-error-boundary';
import { observer } from 'mobx-react';
import { getService } from 'react-in-angularjs';

import { ErrorFallback } from '../../components/ErrorFallback/ErrorFallback';
import { usePageConfig } from '../../hooks/usePageConfig';
import { SOLUTION_TYPE, SolutionType } from '../../constants/user-info/solutionType';
import { solutionsStore } from '../../stores/solutionsStore';

type SystemProvidersProps = {
  children: ReactNode;
};

const themeTypeBySolution: Record<SolutionType, ThemeType> = {
  [SOLUTION_TYPE.NUTRITION]: THEME_TYPES.NUTRITION,
  [SOLUTION_TYPE.SCAN_IQ]: THEME_TYPES.INBODY,
  [SOLUTION_TYPE.CHALLENGE]: THEME_TYPES.INBODY,
};

const SystemProviders = observer(({ children }: SystemProvidersProps) => {
  const { activeSolution } = solutionsStore;
  const solutionTheme = activeSolution && themeTypeBySolution[activeSolution];

  const { theme: pageTheme } = usePageConfig();

  const currentTheme = pageTheme ?? solutionTheme ?? THEME_TYPES.NUTRITION;

  // Sync theme to Angular Material
  useLayoutEffect(() => {
    const $rootScope = getService('$rootScope');

    $rootScope.setTheme(currentTheme);
  }, [currentTheme]);

  // add comment about order of themes selection
  return (
    <ThemeProvider theme={currentTheme}>
      <ErrorBoundary FallbackComponent={ErrorFallback}>{children}</ErrorBoundary>
    </ThemeProvider>
  );
});

export { SystemProviders };
